import { useEffect, useState } from "react";


function Tabs( { tabData = [] } ) {
  const [activeIndex, setActiveIndex] = useState( 0 );
  const [underLineWidth, setUnderLineWidth] = useState( 0 );
  const [underLinePositionY, setUnderLinePositionY] = useState( 0 );

  const [refs] = useState( [] );

  useEffect( () => {
    setUnderLineWidth( refs[activeIndex]?.clientWidth );
    setUnderLinePositionY( refs[activeIndex]?.offsetLeft );
  }, [refs, activeIndex] );

  return (
    <div className="tab" >
      <ul
        style={{
          position: "relative",
          display: "flex",
          listStyle: "none",
          backgroundColor: "#3C4043",
          paddingInlineStart: 0,
          margin: 0,
          padding: "15px 0"
        }}
      >
        {tabData.map( ( tab, index ) => (
          <li className="tabIcon"
            key={index}
            style={{
              padding: "10px ",
              cursor: 'pointer',
              color: activeIndex === index ? "lightblue" : "black"
            }}
            onClick={() => setActiveIndex( index )}
            ref={( ref ) => ( refs[index] = ref )}
          >
            {tab.label}
          </li>
        ) )}
      </ul>
      <span className="tabUnderline"
        style={{
          width: underLineWidth,
          left: underLinePositionY,

        }}
      />
      <div>
        {tabData[activeIndex]?.content}
      </div>
    </div>
  );
}

export default Tabs;